import script from "./AlertGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertGroup.vue?vue&type=script&setup=true&lang=js"

import "./AlertGroup.vue?vue&type=style&index=0&id=cf525b94&lang=postcss"

const __exports__ = script;

export default __exports__